import { getHumanReadableControlIdFromControl } from 'Helpers/ControlFormatter/ControlFormatter';
import { NotificationType, UserNotification } from 'Models/Notification';

/** Given a Notification, determine the name that should be displayed in the UI for it. */
export const getNotificationDisplayName = (notification: UserNotification): string => {
    switch (notification._type) {
        case NotificationType.ACTION_DUE:
            return notification.action.title;
        case NotificationType.CONTROL_ASSESSMENT:
            return getHumanReadableControlIdFromControl(notification.control);
        case NotificationType.EXCEPTION_EXPIRY:
            return notification.exception.title;
        case NotificationType.ISSUE_DUE:
            return notification.issue.title;
        // UCRM
        case NotificationType.UCRM_DUE_DILIGENCE_WORKFLOW_DUE:
            return `${notification.use_case.vendor_name} - ${notification.use_case.name}`;
        case NotificationType.UCRM_FOLDER_EXPIRY:
            return `${notification.business.name} - ${notification.folder.name}`;
        case NotificationType.UCRM_IRQ_DUE:
            return `${notification.use_case.vendor_name} - ${notification.use_case.name}`;
        case NotificationType.UCRM_DUE_DILIGENCE_ASSESSMENT_DUE:
            return `${notification.assessment.name} (${notification.use_case.vendor_name} - ${notification.use_case.name})`;
        // TPRM
        case NotificationType.TPRM_DUE_DILIGENCE_WORKFLOW_DUE:
            return `${notification.third_party_service.vendor_name} - ${notification.third_party_service.name}`;
        case NotificationType.TPRM_FOLDER_EXPIRY:
            return `${notification.third_party.name} - ${notification.folder.name}`;
        case NotificationType.TPRM_IRQ_DUE:
            return `${notification.third_party_service.vendor_name} - ${notification.third_party_service.name}`;
        case NotificationType.TPRM_DUE_DILIGENCE_ASSESSMENT_DUE:
            return `${notification.assessment.name} (${notification.third_party_service.vendor_name} - ${notification.third_party_service.name})`;
    }
};

/** Given a Notification, determine the name that should be displayed in the UI for it, prefixed by the name of the feature it is relevant to. */
export const getNotificationDisplayNameWithFeature = (notification: UserNotification): string => {
    return `${notification._type}: ${getNotificationDisplayName(notification)}`;
};
